import React from "react";

import classes from "./styles.module.scss";

const CreditsChange = ({ credits, isPositive }) => {
    return (
        <div className={classes.creditsChangeContainer}>
            <span
                style={{
                    color: isPositive ? "#18C1AD" : "#222222",
                }}
            >
                {isPositive ? "+ " : "- "}
            </span>
            <span
                style={{
                    color: isPositive ? "#18C1AD" : "#222222",
                }}
            >
                {credits}
            </span>
        </div>
    );
};

export default CreditsChange;
